import { render, staticRenderFns } from "./AccessAuthorityForm.vue?vue&type=template&id=559a5ba8"
import script from "./AccessAuthorityForm.vue?vue&type=script&lang=js"
export * from "./AccessAuthorityForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports